/* eslint-disable jsx-a11y/anchor-is-valid */
import {useState, useEffect} from 'react'
import axios from 'axios'
import apiConnect from '../../../api/apiConnect'
import Swal from 'sweetalert2'
import DataTable from 'react-data-table-component'
import {Link} from 'react-router-dom'
import {useParams} from 'react-router-dom'
import {useThemeMode} from '../../../../_metronic/partials'

const AlarmTab = ({deviceData}) => {
  const deviceId = useParams().deviceId
  const [trigger, setTrigger] = useState(true)
  const [searchTerm, setSearchTerm] = useState('')
  const [deviceAlarm, setDeviceAlarm] = useState([])
  const {mode} = useThemeMode()

  useEffect(() => {
    async function fetchData() {
      try {
        const response = await apiConnect.get(`/v1/devices/alarm-device/${deviceId}`)
        if (response.status == 200 && response.data.length > 0) {
          setDeviceAlarm(response.data)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }
    if (deviceId !== undefined) {
      fetchData()
    }
  }, [trigger, deviceData])

  const columns = [
    {
      name: 'Subject',
      selector: (row) => row.message.subject,
      sortable: true,
      cell: (row) => {
        return (
          <>
            <p>{row.message.subject}</p>
          </>
        )
      },
    },

    {
      name: 'Data',
      selector: (row) => row.timestamp,
      sortable: true,
      cell: (row) => {
        return <p>{getTimeFormat(row.timestamp)}</p>
      },
    },
    {
      name: 'To',
      selector: (row) => row.to,
      sortable: true,
      cell: (row) => {
        return <p>{row.to}</p>
      },
    },
    {
      name: 'State',
      selector: (row) => row.delivery.state,
      sortable: true,
      cell: (row) => {
        return <p>{row.delivery.state}</p>
      },
    },
  ]

  // เพิ่มการกรองข้อมูลบน DataTable ก่อนแสดงผล
  const filteredData = deviceAlarm.filter(
    (device) =>
      device.device_id.toLowerCase().includes(searchTerm.toLowerCase()) ||
      device.to.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <>
      <div className='card mb-5 mb-xl-10'>
        <div className='card-header border-0 pt-2 d-flex justify-content-between align-items-center mb-3 mt-3'>
          <h3 className='card-title align-items-start flex-column'>
            <span className='card-label fw-bold fs-3 mb-1'>
              Device Alarm ({filteredData.length})
            </span>
          </h3>
          <div className='input-group w-100 w-md-auto mt-3'>
            <span className='input-group-text'>
              <i className='fas fa-search'></i>
            </span>
            <input
              type='text'
              className='form-control'
              placeholder='Search...'
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
          </div>
        </div>

        <div className='card-body border-top py-3'>
          <div className='table-responsive'>
            <DataTable
              columns={columns}
              data={filteredData}
              pagination
              paginationPerPage={20}
              paginationRowsPerPageOptions={[20, 50, 100]}
              keyField='parameterId'
              theme={mode === 'dark' ? 'dark' : 'light'}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export {AlarmTab}

function getTimeFormat(timestamp) {
  const createdAt = new Date(timestamp * 1000)
  const formattedDate = createdAt.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  })
  const formattedTime = createdAt.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  })
  const formattedDateTime = `${formattedDate} ${formattedTime}`
  return formattedDateTime
}
